export { default } from "./detailInformationButton";
